import { MaterialFilterGroupView } from "./material-filter-group";
import { SearchModel } from "./../models/search";
import { MaterialFilterView } from "./material-filter";
import {backboneViewProperties} from "../../decorators/backbone-properties";

const template = require<string>("./material-filter-panel.html");
const dom = {
    ALL_RESULTS_LINK: `.js-material[data-material="All Results"]`
};

@backboneViewProperties({
    tagName: "div",
    template: template,
    className: "material-type-filter-panel",
    childView: MaterialFilterView
})
export class MaterialFilterPanelView extends Marionette.LayoutView<SearchModel> {

    public childrenRegion: Marionette.Region;

    constructor(options?) {
        super(options);
        this.setupModelListeners();
    }

    public regions(): any {
        const regions = {
            childrenRegion: ".children-region"
        };
        return regions;
    }

    public events(): Backbone.EventsHash   {
        const events: Backbone.EventsHash = {};

        events[`click ${dom.ALL_RESULTS_LINK}`] = (e) => this.allResultsLinkClicked(e);

        return events;
    }

    public allResultsLinkClicked(e: JQueryEventObject) {
        let anyChanged = false;

        this.model.MaterialFacets.forEach((m) => {
            if (m.Ticked || m.PartiallyTicked) {
                anyChanged = true;
            }
            m.Ticked = false;
            m.PartiallyTicked = false;

            if (m.HasSubFacets) {
                m.SubFacets.forEach((sf) => {
                    sf.Ticked = false;
                });
            }
        });

        if (anyChanged) {
            this.model.filterChangedReRunSearch();
        }

    }

    public onShow() {
        if (this.childrenRegion) {
            this.childrenRegion.show(new MaterialFilterGroupView({model: this.model, collection: this.model.MaterialFacets}));
            this.updateDisplay(!this.model.DisableMaterialFiltering);
        }
        this.updateAllResultsCount();

        this.listenTo(this.model.MaterialFacets, "change:Ticked", this.tickedChanged);
        this.listenTo(this.model, "change:TotalUnfilteredResults", this.updateAllResultsCount);

        this.tickedChanged();
    }

    public tickedChanged() {

        let allCheckboxVal = false;

        if (this.model.MaterialFacets.all((f) => !f.Ticked)) {
            allCheckboxVal = true;
        }

        _.defer(() => {
            this.$(dom.ALL_RESULTS_LINK).find("input").prop("checked", allCheckboxVal);
        });

    }

    public updateAllResultsCount() {
       const val = this.model.TotalResults >= 0 ? this.model.TotalUnfilteredResults : 0;
       this.$(".all-results-count").text(val);
    }

    private setupModelListeners() {
        this.listenTo(this.model, "change:DisableMaterialFiltering", this.disableMaterialFilteringChanged);
    }

    private updateDisplay(show) {
        if (this.childrenRegion) {
            this.$(".disabled-shield").toggle(!show);
        }
    }

    private disableMaterialFilteringChanged(model, prop) {
       this.updateDisplay(!prop);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/material-filter-panel.ts